import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import Select from '../../../components/form/Select';

const propTypes = {
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
};

const SelectField = ({ name, onBlur, ...rest }) => {
  const [field, meta] = useField({ name });

  return (
    <Select
      {...rest}
      name={name}
      value={field.value}
      onSelect={field.onChange}
      onBlur={field.onBlur}
      error={meta.touched && meta.error ? meta.error : null}
    />
  );
};

SelectField.propTypes = propTypes;

export default SelectField;
